var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',[_c('el-card',{attrs:{"shadow":"never"}},[_c('TeamClientsTable',{ref:"clientsTable",attrs:{"account-id":_vm.$route.params.accountId,"team-id":_vm.$route.params.teamId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }